/** Контроль пробігу зміни (backend MileageDeviationStatus); null — немає пробігу Wialon для порівняння */
export type MileageDeviationStatus = 'ok' | 'deviation' | 'reviewed'

export const MILEAGE_DEVIATION_OPTIONS: Array<{ value: MileageDeviationStatus; label: string; color: string }> = [
    { value: 'ok', label: 'У межах норми', color: '#52c41a' },
    { value: 'deviation', label: 'Потребує перевірки', color: '#ff4d4f' },
    { value: 'reviewed', label: 'Перевірено', color: '#8c8c8c' },
]
